module.exports = __webpack_public_path__ + "static/commons-logo-12914b5db6cda071f36026ef8df03c13.jpg";